import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67c2f9ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-md-6 mxauto text-center" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "d-flexjustify-content-center text-center" }
const _hoisted_6 = {
  key: 0,
  class: "my-3 text-danger"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1))
const _hoisted_8 = {
  id: "buttonContainer",
  class: "text-center"
}
const _hoisted_9 = {
  key: 1,
  class: "container"
}
const _hoisted_10 = { class: "row justify-content-center" }
const _hoisted_11 = { class: "col-md-6 mxauto text-center" }
const _hoisted_12 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_answer_view = _resolveComponent("answer-view")!
  const _component_nav_buttons = _resolveComponent("nav-buttons")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.showConfirmationMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                ref: "fader",
                class: _normalizeClass([
            _ctx.fadeQuestionOut ? 'fade-out' : '',
            _ctx.fadeQuestionIn ? 'fade-in' : ''
          ])
              }, [
                _createElementVNode("p", {
                  class: "question mt-5 mb-3",
                  innerHTML: _ctx.question.getText()
                }, null, 8, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.answers, (answer, i) => {
                    return (_openBlock(), _createBlock(_component_answer_view, {
                      key: _ctx.getAnswerKey(answer),
                      questionId: _ctx.question.id,
                      answer: answer,
                      ref_for: true,
                      ref: 
                el => {
                  _ctx.answerElements[i] = el;
                }
              ,
                      onAnswered: _ctx.onContinueClicked
                    }, null, 8, ["questionId", "answer", "onAnswered"]))
                  }), 128))
                ]),
                (_ctx.showAnswerRequiredMessage)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(_ctx.answerRequiredMessage), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_nav_buttons, {
                    previousVisible: _ctx.question.canGoBack,
                    nextVisible: _ctx.question.hasFollowUpQuestion(),
                    previousText: _ctx.navButtonsPreviousText,
                    nextText: "Next Question",
                    onPreviousClicked: _ctx.onPreviousClicked,
                    onNextClicked: _ctx.onContinueClicked
                  }, null, 8, ["previousVisible", "nextVisible", "previousText", "onPreviousClicked", "onNextClicked"])
                ])
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmationMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", null, _toDisplayString(_ctx.confirmationMessageText), 1),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_nav_buttons, {
                  previousText: "No",
                  nextText: "Yes",
                  onPreviousClicked: _ctx.onAnswerRejectedClicked,
                  onNextClicked: _ctx.onAnswerConfirmedClicked
                }, null, 8, ["onPreviousClicked", "onNextClicked"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}